import React, { useMemo, useState } from 'react';
import { Row, Col } from 'tea-component';
import { getGameIdIsSame } from '@op/utils/url';
import DiscussionList from './DiscussionList';
import DiscussionDetail from './DiscussionDetail';
import { IDiscussionItem } from './types';
import { useFontLoading } from '@op/hooks/common';
import { useHotEventContext } from '../../context';
import './index.scss';

/**
 * 热门事件 - 左右分栏面板视图 (V2)
 * 左侧：Discussions 列表（自己管理数据请求） / 右侧：选中项详情
 */
export default function HotEventPanel() {
  const { gameInfo, filter, channelType } = useHotEventContext();
  const [selectItem, setSelectItem] = useState<IDiscussionItem | null>(null);
  const [isDiscussionListEmpty, setIsDiscussionListEmpty] = useState(false);
  const { loading: fontLoading, changeLoading } = useFontLoading();

  // 右侧详情筛选参数：排除左侧列表专用字段（sortBy/top_n/sentiment_type 等），
  // 避免切换左侧排序时触发右侧详情不必要的数据重请求
  const detailFilterParams = useMemo(() => {
    const { isSameId } = getGameIdIsSame(gameInfo);
    if (!isSameId || filter === null) return undefined;
    return {
      ...gameInfo,
      channel_type: channelType,
      filter_keyword_response: true,
      ...(filter || {}),
    };
  }, [filter, gameInfo, channelType]);

  return (
    <div className="dbo-hot-event-panel">
      <Row className="dbo-hot-event-container" gap={20}>
        <Col span={12} className="dbo-hot-event-left-col">
          <DiscussionList
            changeLoading={changeLoading}
            onSelectItem={(item) => {
              setSelectItem(item);
            }}
            onDataStateChange={({ isEmpty }) => {
              setIsDiscussionListEmpty(isEmpty);
            }}
          />
        </Col>
        <Col span={12} className="dbo-hot-event-right-col">
          <DiscussionDetail
            item={selectItem}
            filterParams={detailFilterParams}
            loading={fontLoading || (!isDiscussionListEmpty && !selectItem)}
          />
        </Col>
      </Row>
    </div>
  );
}
